import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs as Adapter } from '@mui/x-date-pickers/AdapterDayjs';
import CssBaseline from '@mui/material/CssBaseline';
import theme from '../theme/theme';

const O2AppUI = (props: any) => {
  const config = {
    dateLocale: 'cs',
    ...props.config,
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={Adapter} adapterLocale={config.dateLocale}>
        {props.children}
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default O2AppUI;
